import React from 'react'
import ReactDOM from 'react-dom/client'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { config } from './wagmi'
import App from './App'
import './index.css'

const queryClient = new QueryClient()

// A render crash would otherwise unmount everything → blank screen.
// This shows the error on-screen instead (no devtools inside Farcaster).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }
  static getDerivedStateFromError(error) {
    return { error }
  }
  render() {
    if (this.state.error) {
      return (
        <main style={{ padding: 20, color: '#ff5470', fontFamily: 'monospace', fontSize: 12 }}>
          <p>SOMETHING BROKE — PLEASE RELOAD</p>
          <pre style={{ whiteSpace: 'pre-wrap', color: '#9be564', fontSize: 10 }}>
            {String(this.state.error?.message || this.state.error)}
          </pre>
        </main>
      )
    }
    return this.props.children
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </WagmiProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
